export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";